import { createApp, configureCompat } from 'vue'
configureCompat({ MODE: 3, ATTR_ENUMERATED_COERCION: 'suppress-warning' })

import { doc, getDoc } from 'firebase/firestore'
import { onAuthStateChanged, signOut } from 'firebase/auth'

import { isNavigationFailure, NavigationFailureType } from 'vue-router'
import router from './router'
import store from './store'
import utils from './js/utils'
import * as rules from './js/validators/rules'
import { auth, db } from './js/db'

// Plugins
import vuetify from './plugins/vuetify'
import numeral from './plugins/numeral'
import moment from './plugins/moment'

import live from './js/live'

import './sass/global.scss' // Import global styles
import 'leaflet/dist/leaflet.css'

import App from './App.vue'

let mounted = false

const redirect = (to) =>
  router.push(to).catch((err) => {
    if (!isNavigationFailure(err, NavigationFailureType.duplicated)) throw err
  })

const app = createApp(App)

app.use(router).use(store).use(vuetify).use(numeral).use(moment).use(live)

app.config.globalProperties.$utils = utils

app.config.globalProperties.$rules = rules
// Vue.config.productionTip has no Vue 3 equivalent — the line is gone, not ported.

onAuthStateChanged(auth, async (user) => {
  let userData
  if (user) {
    const userRef = await getDoc(doc(db, 'users', user.uid))

    if (userRef.exists()) {
      userData = userRef.data()
      userData.isInit = true
      userData.isAuth = true
    } else {
      await signOut(auth).catch((err) => console.error('signOut after missing profile failed:', err))

      userData = {
        isInit: true,
        isAuth: false
      }
    }
  } else {
    userData = {
      isInit: true,
      isAuth: false
    }
  }

  store.commit('setUser', userData)

  // Run initial redirect if needed.
  const { name, meta } = router.currentRoute.value
  if (meta.allowPublic) {
    if (name == 'login' && userData.isAuth) {
      redirect('/')
    }
  } else if (!userData.isAuth) {
    redirect('/user/login')
  } else if (name == 'dash' && !userData.permissions?.uk) {
    redirect('/production')
  }

  if (!mounted) {
    mounted = true
    app.mount('#app')
  }
})
